import {Tooltip} from "antd";
import {
    CheckCircle,
    CheckCircleOutline
} from "@mui/icons-material";
import Button from "@common/Button";
import Card, {CARD} from "@common/Card";
import React, {useContext, useState} from "react";
import ChPieChart from "@common/ChPieChart";
import {STEP_NUMBERS} from "../Data";
import {UserContext} from "@context/UserContext";
import {BrandContext} from "@context/BrandContext";
import axios from "@common/axios";
import PeopleIcon from "@mui/icons-material/People";
import ClassIcon from "@common/icons/ClassIcon";
import PopConfirm from "@common/PopConfirm";

const AssignedTestCard = (props) => {
    const {
        data,
        stepChange,
        updateSelectedTestAssignmentData,
        triggerReload,
        updateSelectedAssignmentData,
        updateSetLoading,
        updateTestResultsDialogData,
        resetTracking
    } = props;
    const brandConfig = useContext(BrandContext);

    const [expanded, setExpanded] = useState(false),
        isDisableSetResults = !data.attempted,
        {user} = useContext(UserContext);

    // const handleExpand = ()=>{
    //     setExpanded(!expanded);
    // }

    const viewStudentResults = () => {
        updateSelectedTestAssignmentData(data);
        stepChange(STEP_NUMBERS.SKILL_SELECT.number);
    }

    const openEditTestAssignment = () => {
        updateSelectedAssignmentData(data);
    }

    const viewAssignedFollowUpWork = () => {
        updateSelectedTestAssignmentData(data);
        stepChange(STEP_NUMBERS.ASSIGNED_FOLLOW_UP_WORK.number);
    }

    const archiveTestAssignment = () => {
        updateSetLoading(()=>{return true;});
        axios.post('/controlCentre/archiveTestAssignment.action', null, {params: {testAssignmentId: data.testAssignmentId}})
        .then(response => {
            updateSetLoading(false);
            triggerReload();
        });
    }

    return (
        <Card className="flex assign-follow-up-work-card" boxRadius={CARD.RADIUS.EXTRA_SMALL}>
            <div className={'flexRow'} style={{width:'100%'}}>
                <div className={'flexColumn'} style={{width: '100%'}}>
                    <div className="padding-l--m padding-r--m flexSpaceBetween flexAlignBaseline">
                        <span className={'flex'}><span className={'ch-med-font ch-bold'}>{data.testName}</span><span
                            className={'margin-l--s ch-med-font flexAlignCentre'}>({data.testGroupName}, {<Tooltip className={'margin-l--s margin-r--xs'}
                            title={(
                                <div>
                                    {data.assignedToStudents ?
                                        <p>Assigned to students {data.studentIds ? '('+data.studentIds.length+')':''} in class</p>
                                        :
                                        <p>Assigned to classes</p>}
                                </div>
                            )}
                            placement="top">
                            {data.assignedToStudents ?
                                <PeopleIcon style={{display:'inlineBlock',position:'relative',top:'1px'}} fontSize={'small'}/> :
                                <ClassIcon style={{display:'inlineBlock',position:'relative',top:'1px'}} fontSize={'small'}/>
                            }
                        </Tooltip>}, <span className={'ch-sml-font margin-l--s'}><span>Assigned: {user.dateFormat.format(data.assignedDate)}</span>&nbsp;<span>By: {data.assignedBy}</span>)</span></span></span>

                        <div className={'flexRow ch-font-small'}>
                            <div className="ch-center-elem flexRow smallGap">
                                <span className={'ch-bold-small'}>Start&nbsp;date: </span><span>{user.dateFormat.format(data.startDate)}</span>
                            </div>,
                            <div className="ch-center-elem flexRow smallGap margin-l--s">
                                <span className={'ch-bold-small'}>End&nbsp;date: </span><span>{user.dateFormat.format(data.endDate)}</span>
                            </div>
                        </div>
                    </div>
                    <div className={'flexRow flexSpaceBetween flexWrap'}>
                        <div className="padding-l--m padding-r--m">
                            <div className={'flexColumn'} style={{gap: '6px', width: '340px'}}>
                                <div className={'flexRow flexWrap'} style={{minHeight:'44px', marginTop:'2px'}}>
                                    <span className={'ch-bold-small'}>Class{data.classes.length === 1 ? '':'es'}:</span>
                                    {data.classes && data.classes.map((clazzData) => {
                                        return (
                                            <Button key={clazzData.classId} size="small"
                                                    style={{paddingLeft: '10px', paddingRight: '10px', borderRadius: '18px'}}
                                                    className="light-theme" type="text"
                                                    onClick={() => updateTestResultsDialogData(data.testAssignmentId, clazzData.classId, clazzData.className, data.studentIds)}>{clazzData.className}{clazzData.studentIds ? ', '+clazzData.studentIds.length + (clazzData.studentIds.length > 1 ? 'students' : 'student') : '' }</Button>
                                        )
                                    })}
                                </div>
                                {/*{expanded &&*/}
                                    <div style={{width:'380px'}}>
                                        <div className={'flexRow padding-t--m padding-b--m'} style={{gap:'10px'}}>
                                            <Button size="small" disabled={data.archived} onClick={openEditTestAssignment}>Edit</Button>
                                            <Button size="small" disabled={!data.feedbackAssigned} onClick={viewAssignedFollowUpWork}>View assigned follow up
                                                work</Button>
                                            <PopConfirm title={<span className={'ch-dashboard-warning-text'}>Permanently archive test assignment?</span>}
                                                        okText='Archive'
                                                        onConfirm={archiveTestAssignment}>
                                                <Button disabled={data.archived} size="small">Archive</Button>
                                            </PopConfirm>
                                        </div>
                                    </div>
                                {/*}*/}
                            </div>
                        </div>
                            <div className="padding-l--m padding-r--m" style={{minWidth:'170px',marginTop:'13px'}}>
                                <div className="assign-test-pie-chart-wrapper flexColumn" style={{marginLeft: '52px'}}>
                                    <ChPieChart width={30} height={30} radius={15} percentFilled={data.percentStudentsComplete}/>
                                    <div className="ch-sml-font ch-center-elem" style={{whiteSpace: 'nowrap', marginTop: '4px'}}>
                                        {data.percentStudentsComplete}% of students completed
                                    </div>
                                </div>
                            </div>
                            <div className="padding-l--m padding-r--m">
                                <div className={'flexColumn'} style={{marginTop:'10px', textAlign: 'center', minWidth: '90px',}}>
                                    <span className="ch-xxxl-font" style={{fontWeight:610}}>{data.testAveragePercent}%</span>
                                    <div style={{textAlign: 'center', marginTop: '4px'}} className="ch-sml-font">Average mark</div>
                                </div>
                            </div>
                        <div className="padding-l--m padding-r--m">
                            <div className={'flexColumn smallGap'} style={{marginTop:'12px'}}>
                                <div style={{textAlign: 'center'}}>
                                    <div
                                        className="ch-sml-font">{data.testAssignmentState === 'COMPLETED' ? 'Test completed' : data.testExpired ? 'Test expired' : 'Test in progress'}</div>
                                    <div className="ch-center-elem ch-sml-font">
                                        {data.feedbackAssigned ?
                                            <CheckCircle className={'ch-check-feedback-assigned'} style={{width: 18, height: 18, marginRight: '4px'}}/>
                                            :
                                            <CheckCircleOutline
                                                style={{fill: 'lightgrey', width: 18, height: 18, marginRight: '4px'}}/>
                                        } {brandConfig.diagnosticFeedbackName} set
                                    </div>
                                </div>
                                <div className="ch-center-elem">
                                    <Tooltip title={isDisableSetResults ? 'The assignment must be expired or complete before feedback can be assigned' : ''}
                                             arrow={false}>
                                        <>
                                            <Button disabled={isDisableSetResults} className="ch-btn-medium" onClick={(e) => {
                                                viewStudentResults(e)
                                                resetTracking();
                                            }}>
                                                <div className={'flexColumn'}>
                                                    <div>View results & set {brandConfig.diagnosticFeedbackName.toLowerCase()}</div>
                                                </div>
                                            </Button>
                                        </>
                                    </Tooltip>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Card>
    )
}
export default AssignedTestCard;
